export const SUCCESSES = [
    {
        id: 1,
        title: "Waschbär im Abfangkorb",
        species: "Waschbär",
        bait: "Frolic-Ringe",
        region: "Niedersachsen",
        date: "2026-03-05",
        image: "/images/blog/blog-waschbaeren-hero.webp",
        quote: "Nach nur zwei Nächten war der erste Waschbär drin. Die Entnahme mit dem Korb ist wirklich stressfrei."
    },
    {
        id: 2,
        title: "Starker Rüde am Waldrand",
        species: "Fuchs",
        bait: "Ranz-Lockstoff & Ei",
        region: "Hessen",
        date: "2026-02-28",
        image: "/images/blog/blog-fangplatz-hero.webp",
        quote: "Der glatte Fallenpass hat sich ausgezahlt. Ein kapitaler Fuchs, sicher gefangen in der Betonrohrfalle."
    },
    {
        id: 3,
        id: 3,
        title: "Nutria-Doublette am Graben",
        species: "Nutria",
        bait: "Apfelstücke",
        region: "Brandenburg",
        date: "2026-03-01",
        image: "/images/blog/blog-nutria-hero.webp",
        quote: "Die Robustheit der Falle ist bei Nutrias entscheidend. Drahtfallen wurden hier oft zerlegt, die Betonrohre halten."
    }
];